// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TestPublish page styles */

.test-publish-page {
  padding: 0;
}

.test-publish-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.test-publish-page .page-header h1 {
  margin: 0 0 0.25rem 0;
  font-size: 1.5rem;
}

.page-subtitle {
  color: #64748b;
  font-size: 0.9rem;
  margin: 0;
}

/* Warning banner */
.warning-banner {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  align-items: flex-start;
}

.warning-banner .warning-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}

.warning-banner strong {
  display: block;
  color: #92400e;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.warning-banner p {
  margin: 0;
  font-size: 0.85rem;
  color: #78350f;
  line-height: 1.4;
}

/* Result toast */
.result-toast {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  font-weight: 500;
}

.result-toast.success {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.result-toast.error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #94a3b8;
}

.empty-state .empty-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 0.75rem;
}

.empty-state h3 {
  margin: 0 0 0.5rem 0;
  color: #475569;
}

.empty-state p {
  font-size: 0.9rem;
}

/* Posts table */
.posts-table-container {
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.posts-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.posts-table thead {
  background: #f8fafc;
}

.posts-table th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #475569;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.posts-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.posts-table tbody tr:hover {
  background: #f8fafc;
}

.posts-table tbody tr.row-publishing {
  background: #eff6ff;
  animation: pulse-bg 1.5s ease-in-out infinite;
}

@keyframes pulse-bg {

  0%,
  100% {
    background: #eff6ff;
  }

  50% {
    background: #dbeafe;
  }
}

/* Cell styles */
.cell-id {
  font-weight: 700;
  color: #64748b;
  font-size: 0.8rem;
  white-space: nowrap;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  color: #1e293b;
}

.user-email {
  font-size: 0.75rem;
  color: #94a3b8;
}

.cell-caption {
  max-width: 200px;
}

.caption-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  color: #334155;
}

.hashtag-count {
  font-size: 0.7rem;
  color: #3b82f6;
  margin-top: 2px;
  display: block;
}

/* Instagram badge */
.ig-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
}

.ig-badge.ig-ok {
  background: #d1fae5;
  color: #065f46;
}

.ig-badge.ig-error {
  background: #fee2e2;
  color: #991b1b;
}

.ig-status-dot {
  font-size: 0.6rem;
}

.ig-status-dot.ok {
  color: #10b981;
}

.ig-status-dot.error {
  color: #ef4444;
}

.no-ig,
.no-video {
  color: #94a3b8;
}

/* Status badges */
.status-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.status-approved {
  background: #dbeafe;
  color: #1e40af;
}

.status-queued {
  background: #fef3c7;
  color: #92400e;
}

.status-failed {
  background: #fee2e2;
  color: #991b1b;
}

.status-publishing {
  background: #ede9fe;
  color: #5b21b6;
}

.status-published {
  background: #d1fae5;
  color: #065f46;
}

.status-partial {
  background: #fff7ed;
  color: #c2410c;
}

.status-default {
  background: #f1f5f9;
  color: #475569;
}

.status-message {
  cursor: help;
  margin-left: 4px;
  font-size: 0.7rem;
}

/* Platform badges */
.platform-badges {
  display: flex;
  gap: 0.35rem;
  flex-wrap: wrap;
}

.platform-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0.15rem 0.4rem;
  border-radius: 5px;
  font-size: 0.75rem;
  cursor: help;
  white-space: nowrap;
}

.platform-badge.platform-ok {
  background: #d1fae5;
  color: #065f46;
}

.platform-badge.platform-error {
  background: #fee2e2;
  color: #991b1b;
}

/* Video link */
.video-link {
  font-size: 1.25rem;
  text-decoration: none;
}

/* Publish button */
.action-buttons {
  display: flex;
  gap: 0.35rem;
}

.btn-publish {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  border: none;
  background: #2563eb;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.btn-publish:hover:not(:disabled) {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.btn-publish:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Retry button */
.btn-retry {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  border: none;
  background: #f59e0b;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.btn-retry:hover:not(:disabled) {
  background: #d97706;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

.btn-retry:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.btn-retry-confirm {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: none;
  background: #f59e0b;
  color: white;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
}

.btn-retry-confirm:hover {
  background: #d97706;
}

.spinner-inline {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Confirm Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 14px;
  padding: 2rem;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.modal-content h2 {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
}

.confirm-details {
  background: #f8fafc;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.confirm-details p {
  margin: 0 0 0.5rem 0;
  font-size: 0.9rem;
}

.confirm-details p:last-child {
  margin-bottom: 0;
}

.confirm-caption {
  color: #64748b;
  font-style: italic;
  font-size: 0.85rem !important;
}

.confirm-warning {
  color: #dc2626;
  font-weight: 600;
  font-size: 0.85rem;
  margin: 0 0 1.25rem 0;
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.btn-secondary {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #475569;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
}

.btn-secondary:hover {
  background: #f8fafc;
}

.btn-danger {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: none;
  background: #dc2626;
  color: white;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.85rem;
}

.btn-danger:hover {
  background: #b91c1c;
}

/* Confirm modal — platform details */
.confirm-platforms {
  margin-top: 0.5rem;
  font-size: 0.85rem;
}

.confirm-platform-list {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.35rem;
  flex-wrap: wrap;
}

.confirm-platform-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0.2rem 0.5rem;
  background: #e2e8f0;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #334155;
  text-transform: capitalize;
}

.confirm-error-detail {
  margin-top: 0.75rem;
  padding: 0.5rem 0.75rem;
  background: #fee2e2;
  border-radius: 6px;
  font-size: 0.85rem;
}

.confirm-error-detail strong {
  color: #991b1b;
  display: block;
  margin-bottom: 0.25rem;
}

.error-message-text {
  margin: 0;
  color: #7f1d1d;
  font-size: 0.8rem;
  word-break: break-word;
}

.confirm-platform-results {
  margin-top: 0.75rem;
  font-size: 0.85rem;
}

.confirm-platform-results strong {
  display: block;
  margin-bottom: 0.35rem;
}

.platform-result-row {
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  margin-bottom: 0.2rem;
  font-size: 0.8rem;
}

.platform-result-row.result-ok {
  background: #d1fae5;
  color: #065f46;
}

.platform-result-row.result-fail {
  background: #fee2e2;
  color: #991b1b;
}

/* ── Platform Toggle Checkboxes (Confirm Modal) ── */
.confirm-platform-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.85rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 2px solid transparent;
  -webkit-user-select: none;
          user-select: none;
  text-transform: capitalize;
}

.confirm-platform-toggle input[type="checkbox"] {
  display: none;
}

.confirm-platform-toggle.toggle-active {
  background: #dbeafe;
  border-color: #3b82f6;
  color: #1e40af;
}

.confirm-platform-toggle.toggle-inactive {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #94a3b8;
}

.confirm-platform-toggle.toggle-inactive:hover:not(.toggle-disabled) {
  background: #e2e8f0;
  border-color: #cbd5e1;
  color: #64748b;
}

.confirm-platform-toggle.toggle-active:hover:not(.toggle-disabled) {
  background: #bfdbfe;
}

.confirm-platform-toggle.toggle-disabled {
  opacity: 0.45;
  cursor: not-allowed;
  text-decoration: line-through;
}

.confirm-platform-list {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}

/* ── Quick Per-Platform Action Buttons ── */
.quick-platform-actions {
  display: flex;
  gap: 0.3rem;
  flex-wrap: wrap;
  margin-top: 0.35rem;
}

.btn-quick-platform {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.btn-quick-platform:hover {
  transform: translateY(-1px);
}

.btn-quick-tiktok {
  background: #111;
  color: #fff;
  border-color: #333;
}

.btn-quick-tiktok:hover {
  background: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.btn-quick-instagram {
  background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
  color: #fff;
}

.btn-quick-instagram:hover {
  box-shadow: 0 2px 8px rgba(225, 48, 108, 0.35);
}

.btn-quick-facebook {
  background: #1877f2;
  color: #fff;
}

.btn-quick-facebook:hover {
  background: #1565d8;
  box-shadow: 0 2px 6px rgba(24, 119, 242, 0.3);
}

.btn-quick-all {
  background: #0f172a;
  color: #fff;
}

.btn-quick-all:hover {
  background: #1e293b;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .test-publish-page .page-header {
    flex-direction: column;
    gap: 0.75rem;
  }

  .posts-table th:nth-child(3),
  .posts-table td:nth-child(3) {
    display: none;
  }

  .cell-caption {
    max-width: 120px;
  }
}

/* ─── Manual Test Publish form ─── */
.manual-publish-form {
  background: #fff;
  border: 1px solid #e0e4e8;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
  max-width: 720px;
}

.manual-publish-form .form-section {
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.manual-publish-form label {
  font-size: 0.92rem;
  color: #2c3e50;
}

.manual-publish-form .required {
  color: #c0392b;
}

.manual-publish-form input[type="url"],
.manual-publish-form textarea {
  padding: 0.6rem 0.7rem;
  font-family: inherit;
  font-size: 0.95rem;
  border: 1px solid #d4d8dc;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.12s ease;
  width: 100%;
  box-sizing: border-box;
}

.manual-publish-form input[type="url"]:focus,
.manual-publish-form textarea:focus {
  border-color: #4a90e2;
}

.manual-publish-form textarea {
  resize: vertical;
  min-height: 110px;
  font-family: 'SF Mono', Menlo, Consolas, monospace;
  font-size: 0.88rem;
  line-height: 1.5;
}

.manual-publish-form .form-hint {
  font-size: 0.78rem;
  color: #6c7a86;
}

.manual-publish-form .form-hint.error {
  color: #c0392b;
}

.platform-radio-group {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.platform-radio {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 0.95rem;
  border: 2px solid #d4d8dc;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.12s ease, background 0.12s ease;
  -webkit-user-select: none;
          user-select: none;
}

.platform-radio input {
  display: none;
}

.platform-radio-icon {
  font-size: 1.1rem;
}

.platform-radio-label {
  font-weight: 500;
  font-size: 0.92rem;
}

.platform-radio.selected {
  border-color: #4a90e2;
  background: #eaf3fc;
}

.platform-radio:hover:not(.selected) {
  border-color: #a4b0bc;
}

.manual-publish-form .form-actions {
  display: flex;
  gap: 0.6rem;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #ecf0f3;
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/TestPublish.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gFAAgF;EAChF,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;EAC1D,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":["/* TestPublish page styles */\n\n.test-publish-page {\n  padding: 0;\n}\n\n.test-publish-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n}\n\n.test-publish-page .page-header h1 {\n  margin: 0 0 0.25rem 0;\n  font-size: 1.5rem;\n}\n\n.page-subtitle {\n  color: #64748b;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Warning banner */\n.warning-banner {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  background: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 10px;\n  margin-bottom: 1.5rem;\n  align-items: flex-start;\n}\n\n.warning-banner .warning-icon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.warning-banner strong {\n  display: block;\n  color: #92400e;\n  margin-bottom: 0.25rem;\n  font-size: 0.9rem;\n}\n\n.warning-banner p {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #78350f;\n  line-height: 1.4;\n}\n\n/* Result toast */\n.result-toast {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.result-toast.success {\n  background: #d1fae5;\n  color: #065f46;\n  border: 1px solid #6ee7b7;\n}\n\n.result-toast.error {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n}\n\n/* Empty state */\n.empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #94a3b8;\n}\n\n.empty-state .empty-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 0.75rem;\n}\n\n.empty-state h3 {\n  margin: 0 0 0.5rem 0;\n  color: #475569;\n}\n\n.empty-state p {\n  font-size: 0.9rem;\n}\n\n/* Posts table */\n.posts-table-container {\n  overflow-x: auto;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n}\n\n.posts-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.posts-table thead {\n  background: #f8fafc;\n}\n\n.posts-table th {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #475569;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.posts-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n.posts-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.posts-table tbody tr.row-publishing {\n  background: #eff6ff;\n  animation: pulse-bg 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-bg {\n\n  0%,\n  100% {\n    background: #eff6ff;\n  }\n\n  50% {\n    background: #dbeafe;\n  }\n}\n\n/* Cell styles */\n.cell-id {\n  font-weight: 700;\n  color: #64748b;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-name {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.user-email {\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n.cell-caption {\n  max-width: 200px;\n}\n\n.caption-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n  color: #334155;\n}\n\n.hashtag-count {\n  font-size: 0.7rem;\n  color: #3b82f6;\n  margin-top: 2px;\n  display: block;\n}\n\n/* Instagram badge */\n.ig-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.ig-badge.ig-ok {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.ig-badge.ig-error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.ig-status-dot {\n  font-size: 0.6rem;\n}\n\n.ig-status-dot.ok {\n  color: #10b981;\n}\n\n.ig-status-dot.error {\n  color: #ef4444;\n}\n\n.no-ig,\n.no-video {\n  color: #94a3b8;\n}\n\n/* Status badges */\n.status-badge {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.status-approved {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.status-queued {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-publishing {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.status-published {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-partial {\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.status-default {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.status-message {\n  cursor: help;\n  margin-left: 4px;\n  font-size: 0.7rem;\n}\n\n/* Platform badges */\n.platform-badges {\n  display: flex;\n  gap: 0.35rem;\n  flex-wrap: wrap;\n}\n\n.platform-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0.15rem 0.4rem;\n  border-radius: 5px;\n  font-size: 0.75rem;\n  cursor: help;\n  white-space: nowrap;\n}\n\n.platform-badge.platform-ok {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.platform-badge.platform-error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Video link */\n.video-link {\n  font-size: 1.25rem;\n  text-decoration: none;\n}\n\n/* Publish button */\n.action-buttons {\n  display: flex;\n  gap: 0.35rem;\n}\n\n.btn-publish {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  border: none;\n  background: #2563eb;\n  color: white;\n  font-weight: 600;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.btn-publish:hover:not(:disabled) {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n}\n\n.btn-publish:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Retry button */\n.btn-retry {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.75rem;\n  border-radius: 8px;\n  border: none;\n  background: #f59e0b;\n  color: white;\n  font-weight: 600;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.btn-retry:hover:not(:disabled) {\n  background: #d97706;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);\n}\n\n.btn-retry:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.btn-retry-confirm {\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: none;\n  background: #f59e0b;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.btn-retry-confirm:hover {\n  background: #d97706;\n}\n\n.spinner-inline {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Confirm Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 14px;\n  padding: 2rem;\n  max-width: 480px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.modal-content h2 {\n  margin: 0 0 1rem 0;\n  font-size: 1.2rem;\n}\n\n.confirm-details {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.confirm-details p {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.9rem;\n}\n\n.confirm-details p:last-child {\n  margin-bottom: 0;\n}\n\n.confirm-caption {\n  color: #64748b;\n  font-style: italic;\n  font-size: 0.85rem !important;\n}\n\n.confirm-warning {\n  color: #dc2626;\n  font-weight: 600;\n  font-size: 0.85rem;\n  margin: 0 0 1.25rem 0;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.btn-secondary {\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  color: #475569;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.btn-secondary:hover {\n  background: #f8fafc;\n}\n\n.btn-danger {\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: none;\n  background: #dc2626;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.btn-danger:hover {\n  background: #b91c1c;\n}\n\n/* Confirm modal — platform details */\n.confirm-platforms {\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n}\n\n.confirm-platform-list {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.35rem;\n  flex-wrap: wrap;\n}\n\n.confirm-platform-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 0.2rem 0.5rem;\n  background: #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #334155;\n  text-transform: capitalize;\n}\n\n.confirm-error-detail {\n  margin-top: 0.75rem;\n  padding: 0.5rem 0.75rem;\n  background: #fee2e2;\n  border-radius: 6px;\n  font-size: 0.85rem;\n}\n\n.confirm-error-detail strong {\n  color: #991b1b;\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.error-message-text {\n  margin: 0;\n  color: #7f1d1d;\n  font-size: 0.8rem;\n  word-break: break-word;\n}\n\n.confirm-platform-results {\n  margin-top: 0.75rem;\n  font-size: 0.85rem;\n}\n\n.confirm-platform-results strong {\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.platform-result-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.3rem 0.5rem;\n  border-radius: 4px;\n  margin-bottom: 0.2rem;\n  font-size: 0.8rem;\n}\n\n.platform-result-row.result-ok {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.platform-result-row.result-fail {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* ── Platform Toggle Checkboxes (Confirm Modal) ── */\n.confirm-platform-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.85rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: 2px solid transparent;\n  user-select: none;\n  text-transform: capitalize;\n}\n\n.confirm-platform-toggle input[type=\"checkbox\"] {\n  display: none;\n}\n\n.confirm-platform-toggle.toggle-active {\n  background: #dbeafe;\n  border-color: #3b82f6;\n  color: #1e40af;\n}\n\n.confirm-platform-toggle.toggle-inactive {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #94a3b8;\n}\n\n.confirm-platform-toggle.toggle-inactive:hover:not(.toggle-disabled) {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n  color: #64748b;\n}\n\n.confirm-platform-toggle.toggle-active:hover:not(.toggle-disabled) {\n  background: #bfdbfe;\n}\n\n.confirm-platform-toggle.toggle-disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  text-decoration: line-through;\n}\n\n.confirm-platform-list {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  margin-top: 0.5rem;\n}\n\n/* ── Quick Per-Platform Action Buttons ── */\n.quick-platform-actions {\n  display: flex;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n  margin-top: 0.35rem;\n}\n\n.btn-quick-platform {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 0.7rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.btn-quick-platform:hover {\n  transform: translateY(-1px);\n}\n\n.btn-quick-tiktok {\n  background: #111;\n  color: #fff;\n  border-color: #333;\n}\n\n.btn-quick-tiktok:hover {\n  background: #333;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n}\n\n.btn-quick-instagram {\n  background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);\n  color: #fff;\n}\n\n.btn-quick-instagram:hover {\n  box-shadow: 0 2px 8px rgba(225, 48, 108, 0.35);\n}\n\n.btn-quick-facebook {\n  background: #1877f2;\n  color: #fff;\n}\n\n.btn-quick-facebook:hover {\n  background: #1565d8;\n  box-shadow: 0 2px 6px rgba(24, 119, 242, 0.3);\n}\n\n.btn-quick-all {\n  background: #0f172a;\n  color: #fff;\n}\n\n.btn-quick-all:hover {\n  background: #1e293b;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .test-publish-page .page-header {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .posts-table th:nth-child(3),\n  .posts-table td:nth-child(3) {\n    display: none;\n  }\n\n  .cell-caption {\n    max-width: 120px;\n  }\n}\n\n/* ─── Manual Test Publish form ─── */\n.manual-publish-form {\n  background: #fff;\n  border: 1px solid #e0e4e8;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n  max-width: 720px;\n}\n\n.manual-publish-form .form-section {\n  margin-bottom: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.manual-publish-form label {\n  font-size: 0.92rem;\n  color: #2c3e50;\n}\n\n.manual-publish-form .required {\n  color: #c0392b;\n}\n\n.manual-publish-form input[type=\"url\"],\n.manual-publish-form textarea {\n  padding: 0.6rem 0.7rem;\n  font-family: inherit;\n  font-size: 0.95rem;\n  border: 1px solid #d4d8dc;\n  border-radius: 6px;\n  outline: none;\n  transition: border-color 0.12s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.manual-publish-form input[type=\"url\"]:focus,\n.manual-publish-form textarea:focus {\n  border-color: #4a90e2;\n}\n\n.manual-publish-form textarea {\n  resize: vertical;\n  min-height: 110px;\n  font-family: 'SF Mono', Menlo, Consolas, monospace;\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n.manual-publish-form .form-hint {\n  font-size: 0.78rem;\n  color: #6c7a86;\n}\n\n.manual-publish-form .form-hint.error {\n  color: #c0392b;\n}\n\n.platform-radio-group {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.platform-radio {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.55rem 0.95rem;\n  border: 2px solid #d4d8dc;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.12s ease, background 0.12s ease;\n  user-select: none;\n}\n\n.platform-radio input {\n  display: none;\n}\n\n.platform-radio-icon {\n  font-size: 1.1rem;\n}\n\n.platform-radio-label {\n  font-weight: 500;\n  font-size: 0.92rem;\n}\n\n.platform-radio.selected {\n  border-color: #4a90e2;\n  background: #eaf3fc;\n}\n\n.platform-radio:hover:not(.selected) {\n  border-color: #a4b0bc;\n}\n\n.manual-publish-form .form-actions {\n  display: flex;\n  gap: 0.6rem;\n  justify-content: flex-end;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #ecf0f3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
